import { resolveFlexibleContentCard } from '../flexible-content-card/resolveFlexibleContentCard';
import type { FrontendWidget } from '../types';
import { FlexibleContentGridComponent } from './FlexibleContentGridComponent';
import type {
  FlexibleContentGridConfig,
  FlexibleContentGridResolved,
} from './types';

export const flexibleContentGridWidget: FrontendWidget<
  FlexibleContentGridConfig,
  FlexibleContentGridResolved
> = {
  componentType: 'widgets.flexible-content-grid',
  displayName: 'Flexible Content Grid',
  defaultValues: {
    columns: '3',
    iconSize: 'medium',
    cardPadding: 'small',
    showInheritedPhoneCta: false,
    cards: [],
  },
  ComponentA: FlexibleContentGridComponent,
  resolveSync: (config) => ({
    columns: config.columns ?? '3',
    background: config.background ?? null,
    iconSize: config.iconSize ?? 'medium',
    cardPadding: config.cardPadding ?? 'small',
    // Already resolved server-side by PhoneResolutionService — pass through.
    // The pair is kept intact here and gated at render time by `showInheritedPhoneCta`, so
    // the resolved block still reports what the chain produced.
    phone: config.phone,
    matelsoPhoneLabel: config.matelsoPhoneLabel,
    showInheritedPhoneCta: config.showInheritedPhoneCta ?? false,
    cards: (config.cards ?? []).map(resolveFlexibleContentCard),
  }),
};
